import type * as Types from '../../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type GetMessagingSettingsByEventIdQueryVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
}>;

export type GetMessagingSettingsByEventIdQuery = {
  __typename?: 'Query';
  getMessagingSettingsByEventId?: {
    __typename?: 'MessagingSettings';
    id: string;
    eventId: string;
    eventDetailsMessagingEnabled: boolean;
    eventDetailsAutomaticRemindersEnabled: boolean;
    rsvpNoCustomRedirectEnabled: boolean;
    rsvpYesCustomRedirectEnabled: boolean;
    rsvpYesCustomRedirectUrl?: string | null;
    rsvpNoCustomRedirectUrl?: string | null;
    rsvpPendingCustomRedirectEnabled: boolean;
    rsvpPendingCustomRedirectUrl?: string | null;
  } | null;
};

export type UpdateEventDetailsMessagingMutationVariables = Types.Exact<{
  payload: Types.UpdateEventDetailsMessagingPayload;
}>;

export type UpdateEventDetailsMessagingMutation = {
  __typename?: 'Mutation';
  updateEventDetailsMessaging: {
    __typename?: 'MessagingSettings';
    id: string;
    eventDetailsMessagingEnabled: boolean;
    eventDetailsAutomaticRemindersEnabled: boolean;
    rsvpNoCustomRedirectEnabled: boolean;
    rsvpYesCustomRedirectEnabled: boolean;
    rsvpYesCustomRedirectUrl?: string | null;
    rsvpNoCustomRedirectUrl?: string | null;
    rsvpPendingCustomRedirectEnabled: boolean;
    rsvpPendingCustomRedirectUrl?: string | null;
  };
};

export const GetMessagingSettingsByEventIdDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetMessagingSettingsByEventId' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getMessagingSettingsByEventId' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventDetailsMessagingEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventDetailsAutomaticRemindersEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rsvpNoCustomRedirectEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rsvpYesCustomRedirectEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rsvpYesCustomRedirectUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rsvpNoCustomRedirectUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rsvpPendingCustomRedirectEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rsvpPendingCustomRedirectUrl' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetMessagingSettingsByEventIdQuery__
 *
 * To run a query within a React component, call `useGetMessagingSettingsByEventIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMessagingSettingsByEventIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMessagingSettingsByEventIdQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetMessagingSettingsByEventIdQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<GetMessagingSettingsByEventIdQuery, GetMessagingSettingsByEventIdQueryVariables>,
) {
  return ApolloReactHooks.useQuery<GetMessagingSettingsByEventIdQuery, GetMessagingSettingsByEventIdQueryVariables>(GetMessagingSettingsByEventIdDocument, baseOptions);
}
export function useGetMessagingSettingsByEventIdLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMessagingSettingsByEventIdQuery, GetMessagingSettingsByEventIdQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<GetMessagingSettingsByEventIdQuery, GetMessagingSettingsByEventIdQueryVariables>(GetMessagingSettingsByEventIdDocument, baseOptions);
}
export type GetMessagingSettingsByEventIdQueryHookResult = ReturnType<typeof useGetMessagingSettingsByEventIdQuery>;
export type GetMessagingSettingsByEventIdLazyQueryHookResult = ReturnType<typeof useGetMessagingSettingsByEventIdLazyQuery>;
export type GetMessagingSettingsByEventIdQueryResult = Apollo.QueryResult<GetMessagingSettingsByEventIdQuery, GetMessagingSettingsByEventIdQueryVariables>;
export const UpdateEventDetailsMessagingDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateEventDetailsMessaging' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateEventDetailsMessagingPayload' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateEventDetailsMessaging' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventDetailsMessagingEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventDetailsAutomaticRemindersEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rsvpNoCustomRedirectEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rsvpYesCustomRedirectEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rsvpYesCustomRedirectUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rsvpNoCustomRedirectUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rsvpPendingCustomRedirectEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rsvpPendingCustomRedirectUrl' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UpdateEventDetailsMessagingMutationFn = Apollo.MutationFunction<UpdateEventDetailsMessagingMutation, UpdateEventDetailsMessagingMutationVariables>;

/**
 * __useUpdateEventDetailsMessagingMutation__
 *
 * To run a mutation, you first call `useUpdateEventDetailsMessagingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventDetailsMessagingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventDetailsMessagingMutation, { data, loading, error }] = useUpdateEventDetailsMessagingMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateEventDetailsMessagingMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateEventDetailsMessagingMutation, UpdateEventDetailsMessagingMutationVariables>,
) {
  return ApolloReactHooks.useMutation<UpdateEventDetailsMessagingMutation, UpdateEventDetailsMessagingMutationVariables>(UpdateEventDetailsMessagingDocument, baseOptions);
}
export type UpdateEventDetailsMessagingMutationHookResult = ReturnType<typeof useUpdateEventDetailsMessagingMutation>;
export type UpdateEventDetailsMessagingMutationResult = Apollo.MutationResult<UpdateEventDetailsMessagingMutation>;
export type UpdateEventDetailsMessagingMutationOptions = Apollo.BaseMutationOptions<UpdateEventDetailsMessagingMutation, UpdateEventDetailsMessagingMutationVariables>;
